import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

const ClientAccounts = () => {

  const { id } = useParams()
  const [account, setAccount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)
  const [selectedAccountId, setSelectedAccountId] = useState('');
  const [selectedAccount, setSelectedAccount] = useState('');
  const [remarks, setRemarks] = useState('')
  const [amount_credited, setAmount_credited] = useState('')
  const [percentage_commission, setPercentage_commission] = useState('')
  const [client_ref_id, setClient_ref_id] = useState(id)
  const [service_ref_id, setService_ref_id] = useState('')
  const [client_id, setClient_id] = useState('')

  // Fetch user accounts
  const getAccounts = useCallback(async (offset, limit, email) => {
    try {
      let query = `&offset=${offset}&limit=${limit}`
      const response = await axios.get(`/service_clients/?client_id=${id}${query}`);
      setAccount(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, [id]);

  useEffect(() => {
    setLoading(true);
    getAccounts((currentPage - 1) * recordsPerPage, recordsPerPage);
  }, [currentPage, recordsPerPage, getAccounts]);


  // bank top up
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`/topup/bank/${selectedAccountId}`, {
        remarks, amount_credited
      })
      setRemarks('')
      setAmount_credited('')
      // Close the modal
      document.getElementById('my_modal_3').close();
      toast.success('Account topped up')
      getAccounts((currentPage - 1) * recordsPerPage, recordsPerPage);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 404) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to top up account.')
      }
      console.log(error)
    }
  }

  // update commission
  const updateCommission = async (e) => {
    e.preventDefault()
    try {
      await axios.put(`/service_clients/commission/${selectedAccountId}`, {
        percentage_commission
      })
      setRemarks('')
      setAmount_credited('')
      // Close the modal
      document.getElementById('my_modal_4').close();
      toast.success('Commission Updated')
      getAccounts((currentPage - 1) * recordsPerPage, recordsPerPage);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 404) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to update commission.')
      }
      console.log(error)
    }
  }

  // add service account
  const addAccount = async (e) => {
    e.preventDefault()
    try {
      await axios.put("/service_clients/", {
        client_ref_id, service_ref_id, client_id
      })
      setService_ref_id('')
      setClient_id('')
      // Close the modal
      document.getElementById('my_modal_5').close();
      toast.success('Service Account Added')
      getAccounts((currentPage - 1) * recordsPerPage, recordsPerPage);
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to add account.')
      }
      console.log(error)
    }
  }

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;

  return (
    <div className='my-2'>
      <div className='bg-white rounded-lg p-4 w-full flex-1 min-w-0'>
        <div className="flex items-center justify-between">
          {(user.role === 'FINANCE_ADMIN' || user.role === 'SYSTEM_ADMIN') && (
            <>
              <button 
                className='bg-[#165277] text-white px-5 py-1 rounded-lg'
                onClick={() => {
                  document.getElementById('my_modal_5').showModal()
                }}
              >Add Account</button>
              <dialog id="my_modal_5" className="modal">
                <div className="modal-box">
                  <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                  </form>
                  <h4 className='text-center'><b>Add Service Client</b></h4>
                  <form onSubmit={addAccount}>
                    <div className='my-2 hidden'>
                      <label htmlFor='client'>Client 
                        <input
                          type='text'
                          required
                          placeholder='Client '
                          className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                          value={client_ref_id}
                          onChange={(e) => setClient_ref_id(e.target.value)}
                        />
                      </label>
                    </div>
                    <div className='my-2'>
                      <label htmlFor='clientid'>Client Id 
                        <input
                          type='text'
                          required
                          placeholder='Client Id '
                          className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                          value={client_id}
                          onChange={(e) => setClient_id(e.target.value)}
                        />
                      </label>
                    </div>
                    <div className='my-2'>
                      <label htmlFor='service'>Service Type 
                        <select 
                          name="" id=""
                          required
                          className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                          value={service_ref_id}
                          onChange={(e) => setService_ref_id(e.target.value)}
                        >
                          <option value="">Service Type</option>
                          <option value="2">Airtime</option>
                          <option value="5">Data</option>
                        </select>
                      </label>
                    </div>
                    <button className='bg-[#134463] text-white px-3 py-1 hover:bg-[#165277] rounded-lg'>Add Account</button>
                  </form>
                </div>
              </dialog>
            </>
          )}
          <h5 className='text-[#165277] font-bold my-4'>Showing {count} / {total} ClientAccounts</h5>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {account.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>Client Id</th>
                      <th className='p-2'>Api Key</th>
                      <th className='p-2'>Units</th>
                      <th className='p-2'>Commission</th>
                      <th className='p-2'>Status</th>
                      <th className='p-2'>Activity</th>
                      {(user.role === 'FINANCE_ADMIN' || user.role === 'SYSTEM_ADMIN') && (
                        <th className='p-2'>Top Up</th>
                      )}
                      {(user.role === 'FINANCE_ADMIN' || user.role === 'SYSTEM_ADMIN') && (
                        <th className='p-2'>Update Commision</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {account.map((accounts) => (
                      <tr key={accounts.id}>
                        <td className='p-2 '>{accounts.id}</td>
                        <td className='p-2'>{accounts.client_id}</td>
                        <td className='p-2'>{accounts.api_key}</td>
                        <td className='p-2'>{accounts.units?.toLocaleString()}</td>
                        <td className='p-2'>{accounts.percentage_commission}%</td>
                        <td className='p-2'>{accounts.is_live === 1 ? 
                          <span className='bg-[#D9F8EB] text-[#2A8B4F] px-4 py-1 rounded-md font-bold'>Live</span> : 
                          <span className='bg-[#FDE6D8] text-[#AC5A2B] px-4 py-1 rounded-md font-bold'>Sandbox</span>}
                        </td>
                        <td className='p-2'>{accounts.is_active === 1 ? (
                          <span className='bg-[#D9E7FA] text-[#215CB1] px-4 py-1 rounded-md font-bold'>Active</span>
                          ) : (
                            <span className='bg-[#FDE6D8] text-[#AC5A2B] px-4 py-1 rounded-md font-bold'>Dormant</span>
                          )}
                        </td>
                        {(user.role === 'FINANCE_ADMIN' || user.role === 'SYSTEM_ADMIN') && (
                          <td className='p-2'>
                            <button 
                              className='bg-[#134463] text-white px-5 py-1 hover:bg-[#165277] rounded-lg whitespace-nowrap' 
                              onClick={() => {
                                document.getElementById('my_modal_3').showModal()
                                setSelectedAccountId(accounts.client_id)
                                setSelectedAccount(accounts.client_id)
                              }}
                            >Top Up</button>
                            <dialog id="my_modal_3" className="modal">
                              <div className="modal-box">
                                <form method="dialog">
                                  {/* if there is a button in form, it will close the modal */}
                                  <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                                </form>
                                <div>
                                  <h4>Bank Top Up for <b className='text-lg'>{selectedAccount}</b></h4>
                                  <form onSubmit={handleSubmit}>
                                    <div className='my-2'>
                                      <label htmlFor='rmarks'>Remarks
                                        <input
                                          type='text'
                                          required
                                          placeholder='Remarks'
                                          className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                                          value={remarks}
                                          onChange={(e) => setRemarks(e.target.value)}
                                        />
                                      </label>
                                    </div>
                                    <div className='my-2'>
                                      <label htmlFor='Amount'>Amount
                                        <input
                                          type='number'
                                          required
                                          placeholder='Amount'
                                          className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                                          value={amount_credited}
                                          onChange={(e) => setAmount_credited(e.target.value)}
                                        />
                                      </label>
                                    </div>
                                    <button className='bg-[#134463] text-white px-5 py-1 hover:bg-[#165277] rounded-lg'>Top Up</button>
                                  </form>
                                </div>
                              </div>
                            </dialog>
                          </td>
                          )}
                        {(user.role === 'FINANCE_ADMIN' || user.role === 'SYSTEM_ADMIN') && (
                          <td className='p-2'>
                            <button 
                              className='bg-[#134463] text-white px-5 py-1 hover:bg-[#165277] rounded-lg whitespace-nowrap' 
                              onClick={()=> {
                                document.getElementById('my_modal_4').showModal()
                                setSelectedAccountId(accounts.id)
                                setSelectedAccount(accounts.client_id)
                              }}
                            >Update Commision</button>
                              <dialog id="my_modal_4" className="modal">
                                <div className="modal-box">
                                  <form method="dialog">
                                    {/* if there is a button in form, it will close the modal */}
                                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                                  </form>
                                  <h4>Update Commission for <b className='text-lg'>{selectedAccount}</b></h4>
                                    <form onSubmit={updateCommission}>
                                      <div className='my-2'>
                                        <label htmlFor='commission'>Commission 
                                          <input
                                            type='number'
                                            required
                                            placeholder='Commission'
                                            className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                                            value={percentage_commission}
                                            onChange={(e) => setPercentage_commission(e.target.value)}
                                          />
                                        </label>
                                      </div>
                                      <button className='bg-[#134463] text-white px-4 hover:bg-[#165277] rounded-full'>Update</button>
                                    </form>
                                </div>
                              </dialog>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientAccounts;
